import { baseApi, hokhuwaApi } from "../lib/axios";
import { EmailInfo } from "../providers/TabProvider";
import { AIInsight, DeepScanResultType, FinderResultType, InsightDataType, ScanGroupResponseType, ScanHistoryItem } from "../types";
import { ThreatType } from "../components/threat/threat.config";

export const scanEmail = async ({
    emailData
}: {
    emailData: Partial<EmailInfo>;
}): Promise<any> => {

    try {
        const response = await baseApi.post('/api/finders', {
            "task_type": "finders",
            "input_text": emailData,
            "client_name": new URLSearchParams(window.location.search).get("space"),
            "email_fingerprint": emailData.emailFingerprint || undefined,
            "internet_message_id": emailData.internetMessageId || undefined,
            "user_info_email": emailData.userInfo.email
        }
        );
        return response.data;
    } catch (error) {
        console.error('Error scanning email:', error);
        return error;
    }
}

export const runDeepScan = async ({
    data,
    emailData
}: {
    data: FinderResultType;
    emailData: Partial<EmailInfo>;
}): Promise<DeepScanResultType | null> => {

    try {
        const response = await baseApi.post('/api/scan/bulk/ioc', {
            "results": data,
            "client_name": new URLSearchParams(window.location.search).get("space"),
            "email_fingerprint": emailData.emailFingerprint || undefined,
            "internet_message_id": emailData.internetMessageId || undefined,
            "subject": emailData.subject || undefined,
            "sender": emailData.sender || undefined,
            "user_info_email": emailData.userInfo.email
        }
        );
        return response.data;
    } catch (error) {
        console.error('Error scanning email:', error);
        return null;
    }
}

export const reportPhishing = async ({
    emailData,
    status,
    groupId,
    aiResult
}: {
    emailData?: Partial<EmailInfo>;
    status?: ThreatType;
    groupId?: string;
    aiResult?: AIInsight
}): Promise<any> => {

    try {
        const response = await hokhuwaApi.post('/external-api/outlook-emails/', {
            user: emailData.userInfo?.email || "",
            client_id: new URLSearchParams(window.location.search).get("client-id"),
            data: {
                ...emailData,
                group_id: groupId,
                ai_result: aiResult
            },
            status,
            email_fingerprint: emailData?.emailFingerprint || undefined,
            internet_message_id: emailData?.internetMessageId || undefined,
            user_info_email: emailData.userInfo.email
        });
        return response.data;
    } catch (error) {
        console.error('Error reporting phishing:', error);
        return error;
    }
}

export const getScanResultByGroupId = async ({
    groupId,
    emailData
}: {
    groupId?: string,
    emailData: Partial<EmailInfo>;
}): Promise<ScanGroupResponseType | null> => {
    try {

        const response = await baseApi.get(`/api/scan/group/`, {
            params: {
                group_id: groupId,
                client_name: new URLSearchParams(window.location.search).get("space"),
                email_fingerprint: emailData.emailFingerprint || undefined,
                internet_message_id: emailData.internetMessageId || undefined,
                user_info_email: emailData.userInfo.email
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error getting scan results:', error);
        return null;
    }
}

export const getScanList = async ({ emailData }: {
    emailData: Partial<EmailInfo>;
}): Promise<ScanHistoryItem[]> => {
    try {
        const response = await baseApi.get('/api/scan/group_list/', {
            params: {
                client_name: new URLSearchParams(window.location.search).get("space") || "apollo_technologies",
                user_info_email: emailData.userInfo.email
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting scan list:', error);
        return [];
    }
}

// Retrieve cached AI insight result for a previously scanned email.
// POST to /api/finders with only the fingerprint — no full email body needed.
export const getInsightByFingerprint = async ({
    emailFingerprint,
    internetMessageId,
    emailData
}: {
    emailFingerprint?: string;
    internetMessageId?: string;
    emailData: Partial<EmailInfo>;
}): Promise<InsightDataType | null> => {
    try {
        const response = await baseApi.post('/api/finders', {
            task_type: "finders",
            client_name: new URLSearchParams(window.location.search).get("space"),
            email_fingerprint: emailFingerprint || undefined,
            internet_message_id: internetMessageId || undefined,
            input_text: emailData || undefined,
            user_info_email: emailData.userInfo.email
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching insight by fingerprint:', error);
        return null;
    }
}
